import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CategorieDailModel {
  public cat_libelle : string;
  public cat_desc : string;
}
